import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "partecon_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const submitEnquiry = (payload) => axios.post(`${API}/enquiries`, payload);

export const trackPrototypeOpen = (key) =>
  axios.post(`${API}/prototype-open`, { key }).catch(() => {});

export const fetchPrototypeStats = () =>
  axios.get(`${API}/prototype-stats`, { headers: { Authorization: `Bearer ${getToken()}` } });

export const askDeckStream = async (question, onChunk) => {
  const resp = await fetch(`${API}/investor/ask`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ question }),
  });
  if (!resp.ok || !resp.body) {
    let msg = "The assistant could not answer right now.";
    try { msg = (await resp.json()).detail || msg; } catch (e) {}
    throw new Error(msg);
  }
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    onChunk(decoder.decode(value, { stream: true }));
  }
};

export const fetchInvestorQuestions = () =>
  axios.get(`${API}/investor/questions`, { headers: { Authorization: `Bearer ${getToken()}` } });

export const fetchPopularQuestions = () => axios.get(`${API}/investor/popular-questions`);

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data.user;
};

export const fetchMe = () =>
  axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${getToken()}` } });

export const fetchEnquiries = () =>
  axios.get(`${API}/enquiries`, { headers: { Authorization: `Bearer ${getToken()}` } });

export const updateEnquiryStatus = (id, status) =>
  axios.patch(`${API}/enquiries/${id}/status`, { status }, { headers: { Authorization: `Bearer ${getToken()}` } });

export const replyEnquiry = (id, message) =>
  axios.post(`${API}/enquiries/${id}/reply`, { message }, { headers: { Authorization: `Bearer ${getToken()}` } });

export const apiErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Something went wrong.";
};
